import { createStyles, withStyles } from '@material-ui/core';
import { Field } from 'formik';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import FormTextField from '../../../common/form/FormTextField';
import FormPasswordField from '../../../common/form/FormPasswordField';
import CommonButton from '../../../common/CommonButton';

const styles = (theme => createStyles({
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
}));

const SettingsDetailsForm = React.forwardRef((props, ref) => {
  const { classes, handleSubmit, dirty, isSubmitting, isValid } = props;
  return (
    <form
      ref={ref}
      className={classes.root}
      onSubmit={handleSubmit}
    >
      <Field
        disabled
        name="username"
        component={FormTextField}
        label={(
          <FormattedMessage
            id="form.user-settings.details.field.username.label"
            defaultMessage="Username"
          />
        )}
      />
  
      <Field
        disabled
        name="email"
        component={FormTextField}
        label={(
          <FormattedMessage
            id="form.user-settings.details.field.email.label"
            defaultMessage="Email"
          />
        )}
      />
  
      <Field
        name="firstName"
        component={FormTextField}
        label={(
          <FormattedMessage
            id="form.user-settings.details.field.first-name.label"
            defaultMessage="First name"
          />
        )}
      />
      
      <Field
        name="lastName"
        component={FormTextField}
        label={(
          <FormattedMessage
            id="form.user-settings.details.field.last-name.label"
            defaultMessage="Last name"
          />
        )}
      />
      
      <Field
        name="oldPassword"
        component={FormPasswordField}
        label={(
          <FormattedMessage
            id="form.user-settings.change-password.field.old-password.label"
            defaultMessage="Current password"
          />
        )}
      />
      
      <Field
        name="newPassword"
        component={FormPasswordField}
        label={(
          <FormattedMessage
            id="form.user-settings.change-password.field.new-password.label"
            defaultMessage="New password"
          />
        )}
      />
      
      <Field
        name="confirmPassword"
        component={FormPasswordField}
        label={(
          <FormattedMessage
            id="form.user-settings.change-password.field.confirm-password.label"
            defaultMessage="Confirm new password"
          />
        )}
      />
      
      <div className={classes.button}>
        <CommonButton
          type="submit"
          label={<FormattedMessage
            id="form.user-settings.details.save"
            defaultMessage="Save"
          />}
          disabled={!dirty || !isValid || isSubmitting}
        />
      </div>
    
    </form>
  );
});

export default withStyles(styles, { name: 'SettingsDetailsForm' })(SettingsDetailsForm);
